module.exports = __webpack_public_path__ + "img/pink-lady.2f980021.jpg";